import { render, staticRenderFns } from "./UpdateContractNameModal.vue?vue&type=template&id=1574b3e7"
import script from "./UpdateContractNameModal.ts?vue&type=script&lang=ts&external"
export * from "./UpdateContractNameModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1574b3e7')) {
      api.createRecord('1574b3e7', component.options)
    } else {
      api.reload('1574b3e7', component.options)
    }
    module.hot.accept("./UpdateContractNameModal.vue?vue&type=template&id=1574b3e7", function () {
      api.rerender('1574b3e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/UpdateContractNameModal.vue"
export default component.exports